const ALLOWED_TAGS = new Set([
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "blockquote",
  "code",
  "pre",
  "ul",
  "ol",
  "li",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "a",
  "hr",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
]);

const BLOCKED_TAGS = new Set(["script", "style", "iframe", "object", "embed", "svg", "math", "form"]);
const ALLOWED_ATTRS_BY_TAG = {
  a: new Set(["href", "title", "target", "rel"]),
};

function isSafeUrl(url = "") {
  const value = String(url || "").trim();
  if (!value) return false;
  if (value.startsWith("#") || value.startsWith("/")) return true;
  return /^(https?:|mailto:|tel:)/i.test(value);
}

export function sanitizeHtml(html = "") {
  if (!html || typeof window === "undefined" || typeof DOMParser === "undefined") {
    return String(html || "");
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(String(html), "text/html");

  doc.body.querySelectorAll("*").forEach((node) => {
    const tag = String(node.tagName || "").toLowerCase();
    if (!tag) return;

    if (BLOCKED_TAGS.has(tag)) {
      node.remove();
      return;
    }

    if (!ALLOWED_TAGS.has(tag)) {
      const parent = node.parentNode;
      if (!parent) return;
      while (node.firstChild) parent.insertBefore(node.firstChild, node);
      parent.removeChild(node);
      return;
    }

    const allowedAttrs = ALLOWED_ATTRS_BY_TAG[tag] || new Set();
    Array.from(node.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value || "";
      if (
        !allowedAttrs.has(name) ||
        name.startsWith("on") ||
        name === "style" ||
        name === "srcset" ||
        ((name === "href" || name === "src") && !isSafeUrl(value))
      ) {
        node.removeAttribute(attr.name);
      }
    });

    if (tag === "a") {
      const href = node.getAttribute("href");
      if (!href) {
        const parent = node.parentNode;
        if (parent) {
          while (node.firstChild) parent.insertBefore(node.firstChild, node);
          parent.removeChild(node);
        }
        return;
      }
      const target = (node.getAttribute("target") || "").toLowerCase();
      if (target === "_blank") {
        node.setAttribute("rel", "noopener noreferrer");
      } else {
        node.removeAttribute("target");
        node.removeAttribute("rel");
      }
    }
  });

  return doc.body.innerHTML;
}
